import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { getFirstAccessibleAppPath } from "../../lib/defaultHomeRoute";

/**
 * Redireciona "/" ou rotas desconhecidas para a primeira tela que o usuário pode abrir
 * (modo granular), evitando cair em /dashboard sem permissão.
 */
const DefaultHomeRedirect = () => {
  const { isAuthenticated, loading, granularPermissionsEnabled, hasEffectivePermission } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-primary" />
          <p className="text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const to = getFirstAccessibleAppPath({ granularPermissionsEnabled, hasEffectivePermission });
  return <Navigate to={to} replace />;
};

export default DefaultHomeRedirect;
